import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_HeaderCard } from 'ui/components/2-molecules/Card/HeaderCard/HeaderCard';
import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { GoToTopNavigation } from '2-feature/Navgation/GoToTopNavigation';
import { UI_ArticleMedia } from 'ui/components/2-molecules/Article/ArticleMedia/ArticleMedia';
import Head from 'next/head';
import { MainRegion } from '1-project/MainRegion/MainRegion';
import { formatDate } from '3-foundation/Localization/formatDate';

interface Props extends Content.Page {
	properties: Content.NewsPageProperties;
}

export const NewsPage = ({ properties }: Props) => {
	const { newsTeaser, newsHeading, newsAuthor, newsDate, newsDateDisplay, newsImage, newsImageAltText, pageSections } = properties ?? {};
	return (
		<>
			<Head>
				<meta name="search-image-url" content={newsImage?.url} />
				<meta name="search-date" content={newsDateDisplay} />
				<meta name="search-rte-teaser" content={newsTeaser} />
				<meta name="search-sort" content={formatDate({ dateInput: newsDate, mode: 'sort' })} />
			</Head>
			<MainRegion>
				<UI_HeaderCard
					teaser={newsTeaser}
					heading={newsHeading}
					kicker={newsAuthor ? `${newsDateDisplay} - ${newsAuthor?.fullName}` : newsDateDisplay}
				/>
				<UI_Container width="Standard">
					{newsImage?.url && <UI_ArticleMedia image={{ url: newsImage?.url }} altText={newsImageAltText} />}
				</UI_Container>

				{pageSections.map((pageSection, index) => (
					<DynamicModule key={index} module={pageSection} />
				))}

				<GoToTopNavigation />
			</MainRegion>
		</>
	);
};
